module.exports = __webpack_public_path__ + "img/invalid-name.881fbc07.png";